const ROUTES = [
  ["GET", "/api/v1/properties", "Properties this key can see"],
  ["GET", "/api/v1/inventory", "Search and filter records: q, identity, operator, device, direction, area, verification, source, anchored, start, end, after_seq, limit (max 500)"],
  ["GET", "/api/v1/inventory/facets", "Values available for each filter"],
  ["GET", "/api/v1/inventory/export?format=csv", "Export filtered records as CSV or JSON, with hashes"],
  ["POST", "/api/v1/validate", "Confirm an agent you saw: { identity, direction, area, start, end } → confirmed or not_observed, with proofs"],
  ["POST", "/api/v1/reconcile", "Send everything you saw: { observed: [...], start, end } → matched, blind spots, not seen at the edge"],
  ["GET", "/api/v1/verify", "Re-check the whole chain"],
  ["GET", "/api/v1/anchors", "Bitcoin anchors; /api/v1/anchors/{seq}/proof downloads the proof file"],
];

export const ApiGuide = ({ base, msp }) => {
  const p = msp ? "&property=PROPERTY_ID" : "";
  const examples = `# Search: verified inbound agents on guest Wi-Fi this month
curl -H "Authorization: Bearer YOUR_KEY" \\
  "${base}/api/v1/inventory?direction=inbound&area=Guest%20Wi-Fi&verification=verified&start=2026-06-01${p}"

# Export as CSV
curl -H "Authorization: Bearer YOUR_KEY" -o inventory.csv \\
  "${base}/api/v1/inventory/export?format=csv${p}"

# Validate what your software saw
curl -X POST -H "Authorization: Bearer YOUR_KEY" -H "Content-Type: application/json" \\
  -d '{${msp ? '"property":"PROPERTY_ID",' : ""}"identity":"ChatGPT","area":"Front desk"}' ${base}/api/v1/validate`;
  return (
    <div className="space-y-4" data-testid="api-guide">
      <h3 className="text-sm font-semibold text-slate-100">How software connects</h3>
      <div className="grid gap-3 sm:grid-cols-2 text-sm">
        <div className="rounded-md border border-[#222D3D] bg-[#0F141C] p-4">
          <p className="text-slate-200">Through the cloud</p>
          <p className="font-mono text-xs text-emerald-300 break-all mt-1" data-testid="api-guide-cloud-url">{base}/api/v1/</p>
        </div>
        <div className="rounded-md border border-[#222D3D] bg-[#0F141C] p-4">
          <p className="text-slate-200">Directly on the DS-1 (inside the property)</p>
          <p className="font-mono text-xs text-emerald-300 break-all mt-1" data-testid="api-guide-device-url">http://DS-1-ADDRESS:8787/api/v1/</p>
          <p className="text-xs text-slate-500 mt-1">Same key, same answers. Turned on with TRUTH_WINDOW_PORT in the sensor setup.</p>
        </div>
      </div>
      <ul className="rounded-md border border-[#222D3D] divide-y divide-[#222D3D] text-sm">
        {ROUTES.map(([m, path, d]) => (
          <li key={path} className="p-3 grid sm:grid-cols-[60px_minmax(0,300px)_1fr] gap-x-3 gap-y-1">
            <span className="font-mono text-xs text-emerald-400">{m}</span>
            <span className="font-mono text-xs text-slate-200 break-all">{path}</span>
            <span className="text-xs text-slate-400">{d}</span>
          </li>
        ))}
      </ul>
      <pre className="rounded-md border border-[#222D3D] bg-[#07090E] p-4 text-[11px] leading-relaxed text-slate-300 overflow-x-auto" data-testid="api-guide-examples">{examples}</pre>
      <p className="text-xs text-slate-500">Records contain no IP addresses or device identifiers, only the network area name. Each carries seq, prev_hash, hash and anchor_seq, so your software can prove nothing was removed or changed.</p>
    </div>
  );
};
